const mapColors = {
  1: '#50BDBB',
  2: '#B9E5E5',
  3: '#585C66',
}

export default mapColors



// WEBPACK FOOTER //
// ./src/components/Visualizations/util/map-colors.js